// PropertyBlockList — renders one editable `<PropertyBlock>` per
// property in the enquiry. Owns no state; parent supplies the list
// of blocks + the mutation handlers.
//
// Extracted from HomeBookingWidget so the widget file stays focused
// on state orchestration and doesn't have to inline the per-block
// prop plumbing.

import React from "react";
import PropertyBlock from "@/components/booking/PropertyBlock";
import { HOTELS } from "@/lib/data";

const PropertyBlockList = ({
  blocks,
  lang,
  today,
  onUpdate,
  onDuplicate,
  onRemove,
  onApplyDatesToAll,
  estimateForBlock,
}) => {
  if (!blocks || blocks.length === 0) return null;
  const multi = blocks.length > 1;
  return (
    <>
      {blocks.map((b) => {
        const hotel = HOTELS.find((h) => h.slug === b.slug);
        return (
          <PropertyBlock
            key={b.rowId}
            block={b}
            hotel={hotel}
            lang={lang}
            today={today}
            onChange={(next) => onUpdate(b.rowId, next)}
            onDuplicate={() => onDuplicate(b.rowId)}
            onRemove={() => onRemove(b.rowId)}
            applyDatesToAll={multi ? () => onApplyDatesToAll(b.rowId) : null}
            estimate={estimateForBlock(b)}
          />
        );
      })}
    </>
  );
};

export default PropertyBlockList;
